import styled from 'styled-components';
import { Grid } from "@mui/material";
import { IThemeProps } from 'component/theme';

export const StyledSignInWidget = styled(Grid)`
  ${({ theme }: IThemeProps) => `
    width: 400px;
    min-width: 300px;
    text-align: center;
    border: 1px solid;
    border-color: ${theme.uptimeColors.grayScales.lightGray} ${theme.uptimeColors.grayScales.lightGray} ${theme.uptimeColors.grayScales.gray};
    background-color: ${theme.uptimeColors.grayScales.white};
    margin-top: 100px;
    .signinwidget-header {
      padding: 30px 90px;
    }
    .signinwidget-body {
      padding: 20px 42px;
      .signinwidget-content {
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
      }
    }
  `}
`;